import { OpenAITextAdapter, AIRequestError } from "ckeditor5-premium-features";
import axios from "axios";

class CustomOpenAITextAdapter extends OpenAITextAdapter {
  constructor(editor) {
    super(editor);
  }

  async prepareMessages(query, context, actionId) {
    /** console.log("output customOpenAITextAdapter"); */
    const messages = await super.prepareMessages(query, context, actionId);

    /** console.log("output query", query);
    *   console.log("output context", context);
    *   console.log("output actionId", actionId);
    *
    *   query -> question to openAI assistant
    *   context -> marked text
    *   actionId -> command -> "custom" as default -> more commands are defined in aiassistant.d.ts
    **/

    if (actionId === 'custom') {
      messages[0].content = "Your task is to generate detailed and comprehensive HTML content accordingly to the given instruction. Never include <img> tag in your response even if asked for. Your answer must be a well-structured and properly formatted HTML code with sufficient detail and explanation. Answer only with the generated HTML content. Do not add any additional remarks or notes. Do not act like a chatbot or a real person.";
    }

    return messages;
  }

  async sendRequest(requestData) {

    const response = await axios.get('/api/ai_assistant/pricing');
    if (response.status === 200) {
      const { required_credits, current_credits } = response.data;
      // console.log('Required credits:', required_credits);
      // console.log('Current credits:', current_credits);
      if (current_credits < required_credits) {
        throw new AIRequestError(`Insufficient credits to use the AI Assistant feature. Required: ${required_credits}, Current: ${current_credits}. Please purchase more credits to continue using this feature.`);
      }
    } else {
      throw new AIRequestError('Failed to fetch pricing information for the AI Assistant feature.');
    }

    return super.sendRequest(requestData);
  }

}

export default CustomOpenAITextAdapter;
